import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const ProductCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Card = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 10px 0;
`;

export const ProductInfo = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const ProductTitle = styled.h6`
  margin: 0;
  line-height: 130%;
  font-size: 14px;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  letter-spacing: 0.13px;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const ProductPrice = styled.p`
  margin-top: 5px;
  font-size: 13px;
`;

export const CheckItOut = styled.a`
  margin-top: 10px;
  color: rgb(0 0 0);
  line-height: 119%;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.14px;
  border-bottom: 1px solid rgb(0 0 0);
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  justify-content: center;
  margin-left: 10px;
  height: 87px;
  overflow: hidden;
  border-radius: 50%;

  img {
    display: block;
    max-width: 100%;
  }
`;

export const ProductButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  width: 100%;
  height: 30px;
  color: #000;
  line-height: 14px;
  font-size: 12px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fontFamily};
  letter-spacing: 0.12px;
  cursor: pointer;
  border: none;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.light};
  outline: none;
  -webkit-box-align: center;
  -webkit-box-pack: center;

  ${({ theme }) => css`
    @media (${theme.mediaMobile}) {
      font-size: 13px;
    }

    @media not (${theme.mediaMobile}) {
      font-size: 12px;
    }
  `}
`;

export const ErrorText = styled.p`
  margin: 20px 0 10px !important;
  color: #c15050;
  line-height: 130%;
  font-size: 14px;
  font-weight: 500;
`;
